import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { AxiosAdapter } from '../../../../../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../../../../../_config/v2/adapters/axios/axios.protocols';
// import Notify from '../../../../../../components/Commons/Notify';

export class Service {
	// async getMagistralQuotation(payload, page) {
	//   return new AxiosAdapter({
	//     method: Http.POST,
	//     url: `${Enviroment.FUNCTION_QUOTATION}/CL/list`,
	//     data: payload,
	//     params: { page },
	//   }).request();
	// }

	async getMagistralQuotation(payload) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral`,
			params: payload,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	// async getBagOnDemand(item) {
	// 	return new AxiosAdapter({
	// 		method: Http.GET,
	// 		url: `${Enviroment.FUNCTION_QUOTATION}/get/cart/${item}`,
	// 	})
	// 		.request()
	// 		.then((response) => {
	// 			return response;
	// 		})
	// 		.catch((error) => {
	// 			console.log(error);
	// 			// Notify({
	// 			// 	title: 'Problemas de Conexión',
	// 			// 	colorTitle: 'ph-main-notification-error-title',
	// 			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
	// 			// 	time: 4,
	// 			// 	image: 'error',
	// 			// 	placement: 'topRight',
	// 			// });
	// 			return null;
	// 		});
	// }

	async getBagOnDemand(item) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/shop-car/${item}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				// Notify({
				// 	title: 'Problemas de Conexión',
				// 	colorTitle: 'ph-main-notification-error-title',
				// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
				// 	time: 4,
				// 	image: 'error',
				// 	placement: 'topRight',
				// });
				return null;
			});
	}

	async getMagistralByID(item) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${item}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				// Notify({
				// 	title: 'Problemas de Conexión',
				// 	colorTitle: 'ph-main-notification-error-title',
				// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
				// 	time: 4,
				// 	image: 'error',
				// 	placement: 'topRight',
				// });
				return null;
			});
	}

	// async getMagistralByID(item) {
	// 	return new AxiosAdapter({
	// 		method: Http.GET,
	// 		url: `${Enviroment.FUNCTION_QUOTATION}/${item}`,
	// 	})
	// 		.request()
	// 		.then((response) => {
	// 			if (response.statusCode === 200) {
	// 				return response.data;
	// 			}

	// 			Notify({
	// 				title: `Ups!`,
	// 				colorTitle: 'ph-main-notification-error-title',
	// 				description: `No tienes respuesta del farmacéutico aún`,
	// 				time: 8,
	// 				image: 'error',
	// 				placement: 'topRight',
	// 			});
	// 			return null;
	// 		})
	// 		.catch((error) => {
	// 			console.log(error);
	// 			// Notify({
	// 			// 	title: 'Problemas de Conexión',
	// 			// 	colorTitle: 'ph-main-notification-error-title',
	// 			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
	// 			// 	time: 4,
	// 			// 	image: 'error',
	// 			// 	placement: 'topRight',
	// 			// });
	// 			return null;
	// 		});
	// }

	async requoteMagistral(body, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/requote`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				return null;
			});
	}
}
